// src/cloudinary.js
// ─────────────────────────────────────────────────────────────
// Add to your .env:
//   REACT_APP_CLOUDINARY_CLOUD_NAME=your_cloud_name
//   REACT_APP_CLOUDINARY_UPLOAD_PRESET=your_unsigned_preset
// ─────────────────────────────────────────────────────────────

export const CLOUD_NAME   = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
export const UPLOAD_PRESET = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET;

/**
 * Uploads a File object to Cloudinary (unsigned upload preset).
 * Returns the secure_url of the uploaded image.
 */
export async function uploadImage(file) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("upload_preset", UPLOAD_PRESET);
  formData.append("folder", "orgalife/products");

  const res = await fetch(
    `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`,
    { method: "POST", body: formData }
  );
  if (!res.ok) throw new Error("Cloudinary upload failed");
  const data = await res.json();
  return data.secure_url;
}
